export default __webpack_public_path__ + "50761c69f9961f6499ad502d63b16426.png";